import { defaultConfig } from './default';

export const se = {
  ...defaultConfig,
  loadGDPRScript: true,
};
